import React, { useEffect } from "react";
import { observer, inject } from "mobx-react";
import MaterialTable, { MTableToolbar } from "material-table";
import {
  UnmatchedAccountsColumns,
  qarManagersOptions,
} from "../../helper/constants";
import Grid from "@material-ui/core/Grid";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { Typography, IconButton } from '@material-ui/core';
import { HtmlTooltip } from "../HtmlTooltip/HtmlTooltip";
import {exportTableToExcel} from "../../helper/fileExtensions";

const QarUnmatchedAccountsInReview = inject("RootStore")(
  observer(({ RootStore, props }) => {
    useEffect(() => {
      RootStore.qarStore.getSnpUnmatchedAccounts(
        RootStore.qarStore.currentlySelectedAccountForReview.id,
        RootStore.qarStore.currentComplianceReviewId,
      );
      RootStore.accountStore.getUpdatedDateBySelectedAccount();
    }, []);

    const tableName = `${RootStore.qarStore.currentlyReviewedSystemForReview.name} / ${RootStore.qarStore.currentlySelectedAccountForReview.name} / Not Recognized Accounts In Review`;

    const tableOptions = {
        ...qarManagersOptions, exportCsv: (columns, data) => {
            let exportColumns = JSON.parse(JSON.stringify(columns));
            let exportData = JSON.parse(JSON.stringify(data));
            exportColumns.find(x => x.field === 'responsibleManager.names').field = `responsibleManager`;
            exportData.forEach((rowData) => {
                rowData.firstName = [rowData.firstName, rowData.lastName].filter(e => e).join(' ');
                rowData.responsibleManager = rowData.responsibleManager.names;
            });
            exportTableToExcel(exportColumns, exportData);
        }
    }

    return (
      <MaterialTable
        title=""
        data={RootStore.qarStore.snpUnmatchedAccounts}
        options={tableOptions}
        columns={[
          ...UnmatchedAccountsColumns,
          {
            title: "Responsible manager",
            field: "responsibleManager.names",
            align: "center",
            width: "100%",
          },
        ]}
        components={{
          Toolbar: (tableProps) => (
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
              spacing={3}
            >
              <Grid item sm={3}>
                <h4 style={{ marginLeft: '10px' }}>
                  {tableName}
                </h4>
              </Grid>
              <Grid item sm={4} style={{ textAlign: 'right' }}>
                <h4>{new Date(RootStore.qarStore.creationDate).toUTCString()}</h4>
                ({new Date(RootStore.qarStore.creationDate).toLocaleString()} local time)
              </Grid>
              <HtmlTooltip
                title={
                  <React.Fragment>
                    <Typography color="inherit" variant="caption">
                      This is the selected system's last successful update date.
                    </Typography>
                  </React.Fragment>
                }
              >
                <IconButton aria-label="delete" size="small">
                  <HelpOutlineIcon fontSize="inherit" />
                </IconButton>
              </HtmlTooltip>
              <Grid item sm={4} style={{ textAlign: 'left' }}>
                <MTableToolbar {...tableProps} />
              </Grid>
            </Grid>
          )
        }}
      />
    );
  })
);

export default QarUnmatchedAccountsInReview;
